// src/views/components/MobileStickyBar/MobileStickyBar.jsx
import React, { useState, useEffect } from 'react';
import { MessageCircle, Info, Download } from 'lucide-react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { useLeadContext } from '../../../controllers/context/LeadContext';
import { LEAD_SOURCES, LEAD_TYPES } from '../../../models/leadTypes';
import { generateWhatsAppLink } from '../../../controllers/services/leadService';
import { useSiteSettings } from '../../../controllers/context/SiteSettingsContext';
import '../components.css';

const MobileStickyBar = () => {
  const { openPopup } = useLeadContext();
  const { whatsappPhone } = useSiteSettings();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const shouldReduceMotion = useReducedMotion();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 150) {
        setIsVisible(false); // Hide on scroll down
      } else {
        setIsVisible(true); // Show on scroll up
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleWhatsApp = () => {
    const msg = "Hi, I'm looking for property options in Ghazipur / Varanasi / Lucknow.";
    window.open(generateWhatsAppLink(msg, whatsappPhone), '_blank');
  };

  const handleGetDetails = () => {
    openPopup('Get Verified Properties', LEAD_SOURCES.MOBILE_STICKY, LEAD_TYPES.BUYER);
  };

  const handleDownloadApp = () => {
    window.open('https://play.google.com/store/apps/details?id=com.nobrokerage.app&pcampaignid=web_share', '_blank');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="mobile-sticky-bar glass"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={
            shouldReduceMotion
              ? { duration: 0.2 }
              : { type: 'spring', stiffness: 350, damping: 25 }
          }
          style={{
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(16px)',
          }}
        >
          <div className="mobile-sticky-actions">
            <motion.button
              className="text-accent"
              onClick={handleWhatsApp}
              whileTap={{ scale: 0.9 }}
              whileHover={{ y: -2 }}
            >
              <MessageCircle size={20} />
              <span>WhatsApp</span>
            </motion.button>
            <motion.button
              className="text-primary font-bold"
              onClick={handleGetDetails}
              whileTap={{ scale: 0.9 }}
              whileHover={{ y: -2 }}
            >
              <Info size={20} />
              <span>Get Details</span>
            </motion.button>
            <motion.button
              className="text-muted"
              onClick={handleDownloadApp}
              whileTap={{ scale: 0.9 }}
              whileHover={{ y: -2 }}
            >
              <Download size={20} />
              <span>App</span>
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileStickyBar;
